import { agent, geoCode } from '../api';
import { getGeoLocation } from '../utility';
let agents;

export async function getGeoCode(keyword) {
  if (!keyword) {
    const { GeoLocation_Longitude, GeoLocation_Latitude } = await getGeoLocation();
    keyword = `{"lat":${GeoLocation_Latitude}, "lng":${GeoLocation_Longitude}}`;
  }
  return geoCode.getGeoCode(keyword);
}

export async function getAllAgents() {
  if (!agents) {
    agents = agent.getAllAgents();
  }
  return agents;
}
